import * as React from "react"


const MenuIcon = ({className, style}: {className?: string, style?: any}) => {
    return  <svg
    className={className}
    style={style}
    width="54"
    height="40"
    viewBox="0 0 14.111282 7.7612762"
    version="1.1"
    id="svg5"
    xmlns="http://www.w3.org/2000/svg"><defs
      id="defs2" /><path
      id="rect37767"
      d="M 2.537788e-6,7.4025259e-6 V 2.1502574 H 14.111293 V 7.4025259e-6 Z m 0,5.6110299974741 v 2.15025 H 14.111293 v -2.15025 z" />
      </svg>
 
}

export default MenuIcon